export const faqData = [
  {
    id: 1,
    question: "How is the EMI for AXIS Bank Personal Loan calculated?",
    answer:
      "The EMI is calculated based on the principal loan amount, the interest rate, and the tenure you select. It’s calculated using the formula for Equated Monthly Installments (EMI).",
  },
  {
    id: 2,
    question: "What is the processing fee for AXIS Bank Personal Loan?",
    answer:
      "AXIS Bank charges a processing fee of 1% to 2% of the loan amount, with a maximum of ₹25,000. Be sure to check this before applying for a loan.",
  },
  {
    id: 3,
    question:
      "How does my credit score affect my personal loan EMI at AXIS Bank?",
    answer:
      "A higher credit score (750+) can help you secure a loan with a lower interest rate, which reduces your EMI. A lower score (below 650) may result in higher rates and EMIs.",
  },
  {
    id: 4,
    question: "Can I change my loan tenure after approval?",
    answer:
      "Once the loan is approved, changing the tenure may not be possible. However, you can inquire about options for restructuring the loan or making partial prepayments.",
  },
  {
    id: 5,
    question: "Can I pay off my AXIS Bank personal loan early?",
    answer:
      "Yes, AXIS Bank allows early repayment, but be sure to check if there are any prepayment charges. Prepaying your loan can save you money on interest.",
  },
  {
    id: 6,
    question:
      "Is it better to take a loan with a longer tenure for a lower EMI?",
    answer:
      "While a longer tenure results in lower EMIs, it increases the total interest paid. If possible, consider a shorter tenure to save on interest, but choose a tenure that fits your monthly budget.",
  },
];
